import ReportToolbarComp from './ReportToolbar';
import ReportToolbarGroupComp from './ReportToolbarGroup';
import ReportToolbarSpacerComp from './ReportToolbarSpacer';

export * from './ReportToolbar';
export * from './ReportToolbarSpacer';
export * from './ReportToolbarNumber';

export const ReportToolbar = ReportToolbarComp;
export const ReportToolbarGroup = ReportToolbarGroupComp;
export const ReportToolbarSpacer = ReportToolbarSpacerComp;
